import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LicenseManager } from 'ag-grid-enterprise';
import * as CryptoJS from 'crypto-js';
import { BaseService } from './base.service';
import { AppContext } from '../../../app/shared/app-context';
import { AG_GRID_INPUTS } from '../../../app/shared/constants/ag-grid-inputs.constants';
import { API_ENDPOINTS } from '../../../app/shared/constants/api-endpoints';
import { LOCAL_STORAGE_KEYS } from '../../../app/shared/constants/claims-ui-constants';
import { Observable } from 'rxjs';
import { ContentResultType } from '../../../app/shared/models/content-result-type.model';

@Injectable({
    providedIn: 'root'
})
export class AgGridLicenseService extends BaseService {
    private shellBaseUrl!: string;
    public agGridLicense?: ContentResultType;

    constructor(public override http: HttpClient, public appContext: AppContext) {
        super(http);
    }

    public getAgGridLicense(): Observable<ContentResultType> {
        const baseUrl = localStorage.getItem(LOCAL_STORAGE_KEYS.shellBaseUrlKey);
        this.shellBaseUrl = baseUrl ?? '';
        if (this.shellBaseUrl) {
            const urlAddress = `${this.shellBaseUrl}/${API_ENDPOINTS.encryptedAgGridLicensekey}`;
            return this.baseGet<ContentResultType>(urlAddress);
        } else {
            return new Observable<ContentResultType>();
        }
    }

    public updateAgGridLicense() {
        this.getAgGridLicense().subscribe((response: ContentResultType) => {
            if (response && response.content) {
                this.agGridLicense = response;
                if (!this.agGridLicense?.content) {
                    throw new Error('License content is missing');
                  }
                const decryptedLicense = this.decryptData(
                    AG_GRID_INPUTS.agGridLicenseEncryptionSecretKey,
                    this.agGridLicense.content
                );
                LicenseManager.setLicenseKey(decryptedLicense);
            }
        });
    }

    public decryptData(keyStr: string, textValue: string): string {
        const key = CryptoJS.enc.Utf8.parse(keyStr);
        const ivData = CryptoJS.lib.WordArray.create();
        const decrypted = CryptoJS.AES.decrypt(textValue, key, { iv: ivData });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
}
